import { OotherSCCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const OotherSCCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case OotherSCCCActionType.OotherSCCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default OotherSCCCReducer
